import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { AvatarSkeletonContainer as n, AvatarSize as a } from "../../../components/Avatar/style.js";
import { DealDescriptionContainer as o } from "../DealDescription/style.js";
import { TextSkeleton as e } from "../../../components/TextSkeleton/index.js";
import { DealBodyContainer as m } from "./style.js";
import { Container as d, TitleContainer as h, AuthorNameSkeleton as r, RightContainer as l } from "../DealDescriptionHeader/style.js";
function A() {
  return /* @__PURE__ */ i(m, { children: [
    /* @__PURE__ */ i(d, { children: [
      /* @__PURE__ */ i(h, { children: [
        /* @__PURE__ */ t(n, { size: a.EXTRA_SMALL, animate: !0 }),
        /* @__PURE__ */ t(r, { children: /* @__PURE__ */ t(e, { width: "200px", animate: !0 }) })
      ] }),
      /* @__PURE__ */ i(l, { children: [
        /* @__PURE__ */ t(r, { children: /* @__PURE__ */ t(e, { width: "100px", animate: !0 }) }),
        /* @__PURE__ */ t(n, { size: a.EXTRA_SMALL, animate: !0 }),
        /* @__PURE__ */ t(r, { children: /* @__PURE__ */ t(e, { width: "80px", animate: !0 }) })
      ] })
    ] }),
    /* @__PURE__ */ i(o, { children: [
      /* @__PURE__ */ t(e, { width: "80%", animate: !0 }),
      /* @__PURE__ */ t(e, { width: "45%", animate: !0 }),
      /* @__PURE__ */ t(e, { width: "80%", animate: !0 }),
      /* @__PURE__ */ t(e, { width: "25%", animate: !0 }),
      /* @__PURE__ */ t(e, { width: "45%", animate: !0 }),
      /* @__PURE__ */ t(e, { width: "80%", animate: !0 }),
      /* @__PURE__ */ t(e, { width: "45%", animate: !0 }),
      /* @__PURE__ */ t(e, { width: "25%", animate: !0 })
    ] })
  ] });
}
export {
  A as DealBodySkeleton
};
